/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getProgramDerivedAddress,
  getStructDecoder,
  getStructEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlyUint8Array,
  type WritableAccount,
} from '@solana/kit';
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from '@solana/program-client-core';
import { INITIALIZER_PROGRAM_ADDRESS } from '../programs';

export const HARVEST_MIGRATED_FEES_DISCRIMINATOR = new Uint8Array([
  63, 77, 73, 117, 2, 43, 255, 176,
]);

export function getHarvestMigratedFeesDiscriminatorBytes() {
  return fixEncoderSize(getBytesEncoder(), 8).encode(
    HARVEST_MIGRATED_FEES_DISCRIMINATOR,
  );
}

export type HarvestMigratedFeesInstruction<
  TProgram extends string = typeof INITIALIZER_PROGRAM_ADDRESS,
  TAccountLaunch extends string | AccountMeta<string> = string,
  TAccountLaunchFeeState extends string | AccountMeta<string> = string,
  TAccountLaunchAuthority extends string | AccountMeta<string> = string,
  TAccountBaseMint extends string | AccountMeta<string> = string,
  TAccountQuoteMint extends string | AccountMeta<string> = string,
  TAccountBaseVault extends string | AccountMeta<string> = string,
  TAccountQuoteVault extends string | AccountMeta<string> = string,
  TAccountPool extends string | AccountMeta<string> = string,
  TAccountLaunchLpPosition extends string | AccountMeta<string> = string,
  TAccountPoolAuthority extends string | AccountMeta<string> = string,
  TAccountPoolVault0 extends string | AccountMeta<string> = string,
  TAccountPoolVault1 extends string | AccountMeta<string> = string,
  TAccountToken0Mint extends string | AccountMeta<string> = string,
  TAccountToken1Mint extends string | AccountMeta<string> = string,
  TAccountCpmmProgram extends string | AccountMeta<string> =
    '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ',
  TAccountBaseTokenProgram extends string | AccountMeta<string> = string,
  TAccountQuoteTokenProgram extends string | AccountMeta<string> = string,
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountLaunch extends string
        ? ReadonlyAccount<TAccountLaunch>
        : TAccountLaunch,
      TAccountLaunchFeeState extends string
        ? WritableAccount<TAccountLaunchFeeState>
        : TAccountLaunchFeeState,
      TAccountLaunchAuthority extends string
        ? ReadonlyAccount<TAccountLaunchAuthority>
        : TAccountLaunchAuthority,
      TAccountBaseMint extends string
        ? ReadonlyAccount<TAccountBaseMint>
        : TAccountBaseMint,
      TAccountQuoteMint extends string
        ? ReadonlyAccount<TAccountQuoteMint>
        : TAccountQuoteMint,
      TAccountBaseVault extends string
        ? WritableAccount<TAccountBaseVault>
        : TAccountBaseVault,
      TAccountQuoteVault extends string
        ? WritableAccount<TAccountQuoteVault>
        : TAccountQuoteVault,
      TAccountPool extends string
        ? WritableAccount<TAccountPool>
        : TAccountPool,
      TAccountLaunchLpPosition extends string
        ? WritableAccount<TAccountLaunchLpPosition>
        : TAccountLaunchLpPosition,
      TAccountPoolAuthority extends string
        ? ReadonlyAccount<TAccountPoolAuthority>
        : TAccountPoolAuthority,
      TAccountPoolVault0 extends string
        ? WritableAccount<TAccountPoolVault0>
        : TAccountPoolVault0,
      TAccountPoolVault1 extends string
        ? WritableAccount<TAccountPoolVault1>
        : TAccountPoolVault1,
      TAccountToken0Mint extends string
        ? ReadonlyAccount<TAccountToken0Mint>
        : TAccountToken0Mint,
      TAccountToken1Mint extends string
        ? ReadonlyAccount<TAccountToken1Mint>
        : TAccountToken1Mint,
      TAccountCpmmProgram extends string
        ? ReadonlyAccount<TAccountCpmmProgram>
        : TAccountCpmmProgram,
      TAccountBaseTokenProgram extends string
        ? ReadonlyAccount<TAccountBaseTokenProgram>
        : TAccountBaseTokenProgram,
      TAccountQuoteTokenProgram extends string
        ? ReadonlyAccount<TAccountQuoteTokenProgram>
        : TAccountQuoteTokenProgram,
      ...TRemainingAccounts,
    ]
  >;

export type HarvestMigratedFeesInstructionData = {
  discriminator: ReadonlyUint8Array;
};

export type HarvestMigratedFeesInstructionDataArgs = {};

export function getHarvestMigratedFeesInstructionDataEncoder(): FixedSizeEncoder<HarvestMigratedFeesInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([['discriminator', fixEncoderSize(getBytesEncoder(), 8)]]),
    (value) => ({
      ...value,
      discriminator: HARVEST_MIGRATED_FEES_DISCRIMINATOR,
    }),
  );
}

export function getHarvestMigratedFeesInstructionDataDecoder(): FixedSizeDecoder<HarvestMigratedFeesInstructionData> {
  return getStructDecoder([
    ['discriminator', fixDecoderSize(getBytesDecoder(), 8)],
  ]);
}

export function getHarvestMigratedFeesInstructionDataCodec(): FixedSizeCodec<
  HarvestMigratedFeesInstructionDataArgs,
  HarvestMigratedFeesInstructionData
> {
  return combineCodec(
    getHarvestMigratedFeesInstructionDataEncoder(),
    getHarvestMigratedFeesInstructionDataDecoder(),
  );
}

export type HarvestMigratedFeesAsyncInput<
  TAccountLaunch extends string = string,
  TAccountLaunchFeeState extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountBaseVault extends string = string,
  TAccountQuoteVault extends string = string,
  TAccountPool extends string = string,
  TAccountLaunchLpPosition extends string = string,
  TAccountPoolAuthority extends string = string,
  TAccountPoolVault0 extends string = string,
  TAccountPoolVault1 extends string = string,
  TAccountToken0Mint extends string = string,
  TAccountToken1Mint extends string = string,
  TAccountCpmmProgram extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
> = {
  launch: Address<TAccountLaunch>;
  launchFeeState?: Address<TAccountLaunchFeeState>;
  launchAuthority?: Address<TAccountLaunchAuthority>;
  baseMint: Address<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  baseVault: Address<TAccountBaseVault>;
  quoteVault: Address<TAccountQuoteVault>;
  pool: Address<TAccountPool>;
  launchLpPosition: Address<TAccountLaunchLpPosition>;
  poolAuthority: Address<TAccountPoolAuthority>;
  poolVault0: Address<TAccountPoolVault0>;
  poolVault1: Address<TAccountPoolVault1>;
  token0Mint: Address<TAccountToken0Mint>;
  token1Mint: Address<TAccountToken1Mint>;
  cpmmProgram?: Address<TAccountCpmmProgram>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
};

export async function getHarvestMigratedFeesInstructionAsync<
  TAccountLaunch extends string,
  TAccountLaunchFeeState extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountBaseVault extends string,
  TAccountQuoteVault extends string,
  TAccountPool extends string,
  TAccountLaunchLpPosition extends string,
  TAccountPoolAuthority extends string,
  TAccountPoolVault0 extends string,
  TAccountPoolVault1 extends string,
  TAccountToken0Mint extends string,
  TAccountToken1Mint extends string,
  TAccountCpmmProgram extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TProgramAddress extends Address = typeof INITIALIZER_PROGRAM_ADDRESS,
>(
  input: HarvestMigratedFeesAsyncInput<
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPool,
    TAccountLaunchLpPosition,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountCpmmProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  HarvestMigratedFeesInstruction<
    TProgramAddress,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPool,
    TAccountLaunchLpPosition,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountCpmmProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram
  >
> {
  // Program address.
  const programAddress = config?.programAddress ?? INITIALIZER_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    launch: { value: input.launch ?? null, isWritable: false },
    launchFeeState: { value: input.launchFeeState ?? null, isWritable: true },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    baseVault: { value: input.baseVault ?? null, isWritable: true },
    quoteVault: { value: input.quoteVault ?? null, isWritable: true },
    pool: { value: input.pool ?? null, isWritable: true },
    launchLpPosition: {
      value: input.launchLpPosition ?? null,
      isWritable: true,
    },
    poolAuthority: { value: input.poolAuthority ?? null, isWritable: false },
    poolVault0: { value: input.poolVault0 ?? null, isWritable: true },
    poolVault1: { value: input.poolVault1 ?? null, isWritable: true },
    token0Mint: { value: input.token0Mint ?? null, isWritable: false },
    token1Mint: { value: input.token1Mint ?? null, isWritable: false },
    cpmmProgram: { value: input.cpmmProgram ?? null, isWritable: false },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Resolve default values.
  if (!accounts.launchFeeState.value) {
    accounts.launchFeeState.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            108, 97, 117, 110, 99, 104, 95, 102, 101, 101, 95, 115, 116, 97,
            116, 101,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'launch',
            accounts.launch.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.launchAuthority.value) {
    accounts.launchAuthority.value = await getProgramDerivedAddress({
      programAddress,
      seeds: [
        getBytesEncoder().encode(
          new Uint8Array([
            108, 97, 117, 110, 99, 104, 95, 97, 117, 116, 104, 111, 114, 105,
            116, 121,
          ]),
        ),
        getAddressEncoder().encode(
          getAddressFromResolvedInstructionAccount(
            'launch',
            accounts.launch.value,
          ),
        ),
      ],
    });
  }
  if (!accounts.cpmmProgram.value) {
    accounts.cpmmProgram.value =
      '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ' as Address<'9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchFeeState', accounts.launchFeeState),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('baseVault', accounts.baseVault),
      getAccountMeta('quoteVault', accounts.quoteVault),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('launchLpPosition', accounts.launchLpPosition),
      getAccountMeta('poolAuthority', accounts.poolAuthority),
      getAccountMeta('poolVault0', accounts.poolVault0),
      getAccountMeta('poolVault1', accounts.poolVault1),
      getAccountMeta('token0Mint', accounts.token0Mint),
      getAccountMeta('token1Mint', accounts.token1Mint),
      getAccountMeta('cpmmProgram', accounts.cpmmProgram),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
    ],
    data: getHarvestMigratedFeesInstructionDataEncoder().encode({}),
    programAddress,
  } as HarvestMigratedFeesInstruction<
    TProgramAddress,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPool,
    TAccountLaunchLpPosition,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountCpmmProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram
  >);
}

export type HarvestMigratedFeesInput<
  TAccountLaunch extends string = string,
  TAccountLaunchFeeState extends string = string,
  TAccountLaunchAuthority extends string = string,
  TAccountBaseMint extends string = string,
  TAccountQuoteMint extends string = string,
  TAccountBaseVault extends string = string,
  TAccountQuoteVault extends string = string,
  TAccountPool extends string = string,
  TAccountLaunchLpPosition extends string = string,
  TAccountPoolAuthority extends string = string,
  TAccountPoolVault0 extends string = string,
  TAccountPoolVault1 extends string = string,
  TAccountToken0Mint extends string = string,
  TAccountToken1Mint extends string = string,
  TAccountCpmmProgram extends string = string,
  TAccountBaseTokenProgram extends string = string,
  TAccountQuoteTokenProgram extends string = string,
> = {
  launch: Address<TAccountLaunch>;
  launchFeeState: Address<TAccountLaunchFeeState>;
  launchAuthority: Address<TAccountLaunchAuthority>;
  baseMint: Address<TAccountBaseMint>;
  quoteMint: Address<TAccountQuoteMint>;
  baseVault: Address<TAccountBaseVault>;
  quoteVault: Address<TAccountQuoteVault>;
  pool: Address<TAccountPool>;
  launchLpPosition: Address<TAccountLaunchLpPosition>;
  poolAuthority: Address<TAccountPoolAuthority>;
  poolVault0: Address<TAccountPoolVault0>;
  poolVault1: Address<TAccountPoolVault1>;
  token0Mint: Address<TAccountToken0Mint>;
  token1Mint: Address<TAccountToken1Mint>;
  cpmmProgram?: Address<TAccountCpmmProgram>;
  baseTokenProgram: Address<TAccountBaseTokenProgram>;
  quoteTokenProgram: Address<TAccountQuoteTokenProgram>;
};

export function getHarvestMigratedFeesInstruction<
  TAccountLaunch extends string,
  TAccountLaunchFeeState extends string,
  TAccountLaunchAuthority extends string,
  TAccountBaseMint extends string,
  TAccountQuoteMint extends string,
  TAccountBaseVault extends string,
  TAccountQuoteVault extends string,
  TAccountPool extends string,
  TAccountLaunchLpPosition extends string,
  TAccountPoolAuthority extends string,
  TAccountPoolVault0 extends string,
  TAccountPoolVault1 extends string,
  TAccountToken0Mint extends string,
  TAccountToken1Mint extends string,
  TAccountCpmmProgram extends string,
  TAccountBaseTokenProgram extends string,
  TAccountQuoteTokenProgram extends string,
  TProgramAddress extends Address = typeof INITIALIZER_PROGRAM_ADDRESS,
>(
  input: HarvestMigratedFeesInput<
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPool,
    TAccountLaunchLpPosition,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountCpmmProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram
  >,
  config?: { programAddress?: TProgramAddress },
): HarvestMigratedFeesInstruction<
  TProgramAddress,
  TAccountLaunch,
  TAccountLaunchFeeState,
  TAccountLaunchAuthority,
  TAccountBaseMint,
  TAccountQuoteMint,
  TAccountBaseVault,
  TAccountQuoteVault,
  TAccountPool,
  TAccountLaunchLpPosition,
  TAccountPoolAuthority,
  TAccountPoolVault0,
  TAccountPoolVault1,
  TAccountToken0Mint,
  TAccountToken1Mint,
  TAccountCpmmProgram,
  TAccountBaseTokenProgram,
  TAccountQuoteTokenProgram
> {
  // Program address.
  const programAddress = config?.programAddress ?? INITIALIZER_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    launch: { value: input.launch ?? null, isWritable: false },
    launchFeeState: { value: input.launchFeeState ?? null, isWritable: true },
    launchAuthority: {
      value: input.launchAuthority ?? null,
      isWritable: false,
    },
    baseMint: { value: input.baseMint ?? null, isWritable: false },
    quoteMint: { value: input.quoteMint ?? null, isWritable: false },
    baseVault: { value: input.baseVault ?? null, isWritable: true },
    quoteVault: { value: input.quoteVault ?? null, isWritable: true },
    pool: { value: input.pool ?? null, isWritable: true },
    launchLpPosition: {
      value: input.launchLpPosition ?? null,
      isWritable: true,
    },
    poolAuthority: { value: input.poolAuthority ?? null, isWritable: false },
    poolVault0: { value: input.poolVault0 ?? null, isWritable: true },
    poolVault1: { value: input.poolVault1 ?? null, isWritable: true },
    token0Mint: { value: input.token0Mint ?? null, isWritable: false },
    token1Mint: { value: input.token1Mint ?? null, isWritable: false },
    cpmmProgram: { value: input.cpmmProgram ?? null, isWritable: false },
    baseTokenProgram: {
      value: input.baseTokenProgram ?? null,
      isWritable: false,
    },
    quoteTokenProgram: {
      value: input.quoteTokenProgram ?? null,
      isWritable: false,
    },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Resolve default values.
  if (!accounts.cpmmProgram.value) {
    accounts.cpmmProgram.value =
      '9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ' as Address<'9PSxVPoPfnbZ8Q1uQhgS6ZxvBjFboZtebNsu34umxkgQ'>;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, 'programId');
  return Object.freeze({
    accounts: [
      getAccountMeta('launch', accounts.launch),
      getAccountMeta('launchFeeState', accounts.launchFeeState),
      getAccountMeta('launchAuthority', accounts.launchAuthority),
      getAccountMeta('baseMint', accounts.baseMint),
      getAccountMeta('quoteMint', accounts.quoteMint),
      getAccountMeta('baseVault', accounts.baseVault),
      getAccountMeta('quoteVault', accounts.quoteVault),
      getAccountMeta('pool', accounts.pool),
      getAccountMeta('launchLpPosition', accounts.launchLpPosition),
      getAccountMeta('poolAuthority', accounts.poolAuthority),
      getAccountMeta('poolVault0', accounts.poolVault0),
      getAccountMeta('poolVault1', accounts.poolVault1),
      getAccountMeta('token0Mint', accounts.token0Mint),
      getAccountMeta('token1Mint', accounts.token1Mint),
      getAccountMeta('cpmmProgram', accounts.cpmmProgram),
      getAccountMeta('baseTokenProgram', accounts.baseTokenProgram),
      getAccountMeta('quoteTokenProgram', accounts.quoteTokenProgram),
    ],
    data: getHarvestMigratedFeesInstructionDataEncoder().encode({}),
    programAddress,
  } as HarvestMigratedFeesInstruction<
    TProgramAddress,
    TAccountLaunch,
    TAccountLaunchFeeState,
    TAccountLaunchAuthority,
    TAccountBaseMint,
    TAccountQuoteMint,
    TAccountBaseVault,
    TAccountQuoteVault,
    TAccountPool,
    TAccountLaunchLpPosition,
    TAccountPoolAuthority,
    TAccountPoolVault0,
    TAccountPoolVault1,
    TAccountToken0Mint,
    TAccountToken1Mint,
    TAccountCpmmProgram,
    TAccountBaseTokenProgram,
    TAccountQuoteTokenProgram
  >);
}

export type ParsedHarvestMigratedFeesInstruction<
  TProgram extends string = typeof INITIALIZER_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    launch: TAccountMetas[0];
    launchFeeState: TAccountMetas[1];
    launchAuthority: TAccountMetas[2];
    baseMint: TAccountMetas[3];
    quoteMint: TAccountMetas[4];
    baseVault: TAccountMetas[5];
    quoteVault: TAccountMetas[6];
    pool: TAccountMetas[7];
    launchLpPosition: TAccountMetas[8];
    poolAuthority: TAccountMetas[9];
    poolVault0: TAccountMetas[10];
    poolVault1: TAccountMetas[11];
    token0Mint: TAccountMetas[12];
    token1Mint: TAccountMetas[13];
    cpmmProgram: TAccountMetas[14];
    baseTokenProgram: TAccountMetas[15];
    quoteTokenProgram: TAccountMetas[16];
  };
  data: HarvestMigratedFeesInstructionData;
};

export function parseHarvestMigratedFeesInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedHarvestMigratedFeesInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 17) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 17,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      launch: getNextAccount(),
      launchFeeState: getNextAccount(),
      launchAuthority: getNextAccount(),
      baseMint: getNextAccount(),
      quoteMint: getNextAccount(),
      baseVault: getNextAccount(),
      quoteVault: getNextAccount(),
      pool: getNextAccount(),
      launchLpPosition: getNextAccount(),
      poolAuthority: getNextAccount(),
      poolVault0: getNextAccount(),
      poolVault1: getNextAccount(),
      token0Mint: getNextAccount(),
      token1Mint: getNextAccount(),
      cpmmProgram: getNextAccount(),
      baseTokenProgram: getNextAccount(),
      quoteTokenProgram: getNextAccount(),
    },
    data: getHarvestMigratedFeesInstructionDataDecoder().decode(
      instruction.data,
    ),
  };
}
